import React, { useMemo } from 'react'
import {
  makeStyles,
  createStyles,
  withStyles,
  useTheme,
  useMediaQuery,
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
} from '@material-ui/core'
import { matchPath } from 'react-router'
import { Route, Switch, useLocation, useRouteMatch, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import OrderConfirm from '../../components/Order/Confirm'
import OrderInfo from 'src/mobile/pages/order/OrderInfo'
import SignIn from '../auth/SignIn'
import SignUp from '../auth/SignUp'
import MobileForgotPassword from '../auth/ForgotPassword'

import { ReactComponent as Return } from '../../../assets/icons/Return.svg'
import Paying from 'src/mobile/pages/order/Paying'
import InfoWrapper from 'src/mobile/components/InfoWrapper'
import { ReactComponent as Step1 } from 'src/mobile/assets/icons/booking-step-1.svg'
import { ReactComponent as Step2 } from 'src/mobile/assets/icons/booking-step-2.svg'
import { ReactComponent as Step3 } from 'src/mobile/assets/icons/booking-step-3.svg'
// import { ReactComponent as Step4 } from 'src/mobile/assets/icons/booking-step-4.svg'
// import classnames from 'classnames'

const STEPS = [
  { label: 'glossary.submit_order', path: '/add-order/', icon: Step1 },
  { label: 'glossary.appointment_process_list.3', path: '/add-order/paying/:orderNumber', icon: Step2 },
  { label: 'glossary.appointment_process_list.4', path: '/add-order/success/:orderNumber', icon: Step3 },
  // { label: 'glossary.ask_clinic', path: '', icon: Step4 },
]

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      marginTop: 1,
    },
    stepper: {
      padding: theme.spacing(0.5, 0),
    },
    stepperPc: {
      maxWidth: 400,
      margin: '0 auto',
      paddingTop: 0,
    },
    stepIconSize: {
      width: theme.spacing(3.75),
      height: theme.spacing(3.75),
    },
    stepIcon: {
      '& path': {
        fill: theme.palette.grey[200],
      },
      '&.MuiStepIcon-active': {
        background: 'red',
      },
    },

    strokeStepIcon: {
      '& path': {
        stroke: theme.palette.grey[200],
      },
    },
    activeStepIcon: {
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
    strokeActiveStepIcon: {
      '& path': {
        stroke: theme.palette.secondary.main,
      },
    },
    stepLayer: { margin: '0 auto', borderBottom: '1px solid #E5E7EB' },

    step: {
      padding: 0,
    },
    stepLabel: {
      margin: '0 auto',
      color: theme.palette.grey[200],
      fontSize: theme.typography.body2.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: `${theme.spacing(1)}px !important`,
    },
    watchOut: {
      textDecoration: 'underline',
      padding: theme.spacing(2, 0, 0, 2),
    },
    card: {
      maxWidth: 650,
      margin: '0 auto',
    },
    back: {
      cursor: 'pointer',
    },
  }),
)

const DashedStepConnector = withStyles((theme) => ({
  alternativeLabel: {
    top: 15,
  },
  line: {
    borderTop: `1px dashed ${theme.palette.grey[200]}`,
  },
  active: {
    '& $line': {
      borderTop: `1px dashed ${theme.palette.secondary.main}`,
    },
  },
  completed: {
    '& $line': {
      borderTop: `1px dashed ${theme.palette.secondary.main}`,
    },
  },
}))(StepConnector)

const AddOrder = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const { pathname } = useLocation()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isPayingSuccessPage = useRouteMatch(`/${i18n.language}/add-order/success/:orderNumber`)
  const isSign =
    useRouteMatch(`/${i18n.language}/add-order/signin`) ||
    useRouteMatch(`/${i18n.language}/add-order/signup`) ||
    useRouteMatch(`/${i18n.language}/add-order`)
  const paying = useRouteMatch(`/${i18n.language}/add-order/paying`)
  const history = useHistory()

  const originActiveStep = useMemo(() => {
    if (matchPath(pathname, { path: `/${i18n.language}/add-order/signin`, exact: true })) return 0
    if (matchPath(pathname, { path: `/${i18n.language}/add-order`, exact: true })) return 1

    const matchPaying = matchPath(pathname, { path: `/${i18n.language}/add-order/paying/`, exact: true })
    if (matchPaying) return 2
    const matchIndex = STEPS.findIndex((step) => matchPath(pathname, { path: step.path, exact: true }))
    return matchIndex + 1 || 0
  }, [])

  return (
    <Box className={classes.root}>
      {!isPayingSuccessPage && (
        <InfoWrapper className={classes.stepLayer}>
          <Box fontWeight={600} fontSize={16} textAlign="center" mb={1}>
            {t('common.check_out')}
          </Box>
          <Box
            mt={1}
            color="primary.main"
            fontSize={14}
            fontWeight={700}
            border="1px solid #E5E7EB"
            borderRadius="50%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="30px"
            height="30px"
            ml={isMobile ? 0 : '32px'}
            top={isMobile ? 85 : 30}
            position="absolute"
            className={classes.back}
            onClick={() => {
              if (isSign) {
                if (paying) {
                  if (location?.state.from === 'list') {
                    history.push(`/${i18n.language}/profile/order`)
                  } else if (location?.state.from === 'orderInfo') {
                    history.push(`/${i18n.language}/profile/order/${location?.state.orderNumber}`)
                  } else {
                    history.push(`/${i18n.language}/add-order`)
                  }
                } else {
                  history.push(`/${i18n.language}/preOrder`)
                }
              }
            }}
          >
            <Return />
          </Box>
          <Stepper
            className={isMobile ? classes.stepper : classes.stepperPc}
            activeStep={originActiveStep}
            alternativeLabel
            connector={<DashedStepConnector />}
          >
            {STEPS.map((label, i) => (
              <Step
                className={classes.step}
                classes={{
                  completed: classes.activeStepIcon,
                }}
                key={label}
              >
                <StepLabel
                  classes={{
                    label: classes.stepLabel,
                    completed: classes.activeStepIcon,
                  }}
                  StepIconProps={{
                    icon: i,
                  }}
                />
              </Step>
            ))}
          </Stepper>
        </InfoWrapper>
      )}
      <Switch>
        <Route exact path={`/${i18n.language}/add-order/signup`}>
          <SignUp source="order" />
        </Route>
        <Route exact path={`/${i18n.language}/add-order/signin`}>
          <SignIn source="order" />
        </Route>
        <Route exact path={`/${i18n.language}/add-order/forgot-password`}>
          <MobileForgotPassword source="order" />
        </Route>
        <Route exact path={`/${i18n.language}/add-order/`}>
          <OrderConfirm />
        </Route>
        <Route exact path={`/${i18n.language}/add-order/paying/:orderNumber`}>
          <OrderInfo step={originActiveStep} />
        </Route>
        <Route exact path={`/${i18n.language}/add-order/success/:orderNumber`}>
          <Box className={isMobile ? {} : classes.card}>
            <OrderInfo />
          </Box>
        </Route>
        <Route exact path={`/${i18n.language}/add-order/paying/`}>
          <Paying step={originActiveStep} />
        </Route>
      </Switch>
    </Box>
  )
}

export default AddOrder
